import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

import { publicationApi } from '@/src/features/publication/api/publicationApi'
import { PUBLICATION_FILTER, PUBLICATION_ORDER } from '@/src/features/publication/models/publication.constants'

import { COMMUNITY_LIFETIME } from '../models/community.constants'

type TUsePublicationsOfCommunityProps = {
  id: number
  enabled: boolean
  type?: COMMUNITY_LIFETIME
}

const publicationFields: ('sharesCount' | 'isRead')[] = ['sharesCount', 'isRead']

export const getPublicationsOfCommunityOptions = ({ id, type, enabled }: TUsePublicationsOfCommunityProps) =>
  infiniteQueryOptions({
    queryKey: ['publications_of_community', id, type],
    queryFn: ({ signal, pageParam }) =>
      publicationApi.getPublications<{ fields: ('sharesCount' | 'isRead')[] }, TNoMoreProps>(
        {
          community: id,
          fields: publicationFields,
          order:
            type === COMMUNITY_LIFETIME.EVERLASTING
              ? PUBLICATION_ORDER.ORDER_FRESHNESS
              : PUBLICATION_ORDER.ORDER_OLDNESS,
          filter: PUBLICATION_FILTER.FILTER_PUBLISHED,
          addScheduled: type !== COMMUNITY_LIFETIME.EVERLASTING,
          ...pageParam,
        },
        { signal, fields: publicationFields },
      ),
    getNextPageParam: (lastPage, _pages, { limit, offset }) =>
      lastPage.length === limit ? { offset: offset + limit, limit } : null,
    initialPageParam: {
      offset: 0,
      limit: 10,
    },
    select: ({ pages }) => pages.flat(),
    enabled,
  })

export const usePublicationsOfCommunityQuery = ({ id, type, enabled }: TUsePublicationsOfCommunityProps) =>
  useInfiniteQuery(getPublicationsOfCommunityOptions({ id, type, enabled }))
